//DESENVOLVIMENTO
//export const REACT_APP_URL_API        =  "http://localhost:26002/distvaf"
//export const REACT_APP_KEYCLOACK_URL  =  "https://keycloak-hom.fazenda.mg.gov.br/"
//export const KEYCLOACK_REALM = "distvaf"

//HOMOLOGACAO
//export const URL_API        =  "https://hdistvaf-backend.fazenda.mg.gov.br/distvaf"
//export const KEYCLOACK_URL  =  "https://keycloak-hom.fazenda.mg.gov.br/"
//export const KEYCLOACK_REALM = "distvaf"

//PRODUÇAO
export const URL_API        =  "https://distvaf-backend.fazenda.mg.gov.br/distvaf"
export const KEYCLOACK_URL  =  "https://acesso.fazenda.mg.gov.br/"
export const KEYCLOACK_REALM = "intranet"

//export const REACT_APP_URL_API   =  process.env.REACT_APP_URL_API
//export const REACT_APP_KEYCLOACK_URL   =  process.env.KEYCLOACK_URL

//export const URL_API_DEV = "http://localhost:26002/distvaf"
//export const URL_API_NEREU = "http://nereu.fazenda.mg.gov.br:26002/distvaf" https://hdistvaf-backend.fazenda.mg.gov.br/distvaf
//export const URL_API_NICON = "http://nicon.fazenda.mg.gov.br:26002/distvaf"  https://distvaf-backend.fazenda.mg.gov.br/distvaf

